export default "__VITE_ASSET__CCkPytdl__"